import { MutableRefObject, useEffect } from 'react';

const useClickOutside = (
  refs: MutableRefObject<HTMLElement | null>[],
  handler,
  deps?: any[],
) =>
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refs.every((ref) => !ref.current?.contains(event.target))) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handler, refs, ...(deps || [])]);

export default useClickOutside;
